// LAN-control mode bootstrap.
//
// When the operator's Electron app shows the "control" QR, it embeds a host-issued
// LAN token. The scanned URL loads the web app at http://<lan-ip>:<port>/?lanToken=…
// — initLanControl() pulls that token out of the URL, persists it in sessionStorage
// so it survives navigation, and strips it from the address bar. Subsequent REST
// calls use it via X-Desktop-Token (configured in main.tsx), and the Clerk gate is
// skipped (the device is authorised as the operator's org for the token's lifetime).

const LAN_TOKEN_KEY = 'proclaim_lan_token';

export function initLanControl(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get('lanToken');
    if (fromUrl) {
      sessionStorage.setItem(LAN_TOKEN_KEY, fromUrl);
      url.searchParams.delete('lanToken');
      window.history.replaceState({}, '', url.toString());
    }
    return sessionStorage.getItem(LAN_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getLanToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(LAN_TOKEN_KEY);
  } catch {
    return null;
  }
}
